import type { BoxProps } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';
import type { ReactNode, RefObject } from 'react';

export interface MessageComposerProps extends BoxProps {
  headerExtra?: ReactNode;
  children: ReactNode;
  ref?: RefObject<HTMLElement | null>;
  sendMessageDisabled?: boolean;
}

function MessageComposer({
  headerExtra,
  children,
  ref,
  sendMessageDisabled,
  ...props
}: MessageComposerProps) {
  const { borderColor, ...rest } = props;

  const cssProps = useMemo(() => {
    return {
      pointerEvents: sendMessageDisabled ? 'none' : 'auto',
      opacity: sendMessageDisabled ? 0.5 : 1,
      bgColor: sendMessageDisabled ? 'bg.subtle' : 'bg.panel',
    };
  }, [sendMessageDisabled]);

  return (
    <Box
      className="MessageComposer"
      ref={ref}
      p="2.5"
      mx="2.5"
      mb="2.5"
      borderRadius="lg"
      border="1px solid"
      borderColor={props.borderColor || 'border.muted'}
      {...cssProps}
      {...rest}
    >
      {headerExtra && <Box className="MessageComposerHeader">{headerExtra}</Box>}
      <Box
        className="MessageComposerBody"
        display="flex"
        alignItems="flex-end"
        flexWrap="wrap"
        justifyContent="flex-end"
        gap="0"
        fontSize="sm"
      >
        {children}
      </Box>
    </Box>
  );
}

const MemoizedMessageComposer = memo(MessageComposer);

export { MemoizedMessageComposer as MessageComposer };
